export const DHARA_OPTIONS = [
  { value: '30_30', label: '30 + 30' },
  { value: '30_15', label: '30 + 15' },
  { value: '15_15', label: '15 + 15' },
  { value: '30_day', label: '30 + day' },
  { value: '15_day', label: '15 + day' }
];

/** Default dhara on VPS A — controls how many days interest is charged. */
export const DEFAULT_DHARA = '30_day';

export function formatDhara(value) {
  const opt = DHARA_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : value || '';
}
